var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('nuxt-link',{attrs:{"to":_vm.to}},[_c('div',{staticClass:"more-btn"},[_vm._v("\n        "+_vm._s(_vm.label || _vm.$t('products.view_more'))+"\n    ")])]):_c('button',{staticClass:"more-btn",on:{"click":_vm.cb}},[_vm._v("\n    "+_vm._s(_vm.label || _vm.$t('products.view_more'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }